import {
  Button,
  CopyText,
  FieldInfoGroup,
  SocialsContactModal,
} from '@/components';
import { externalLinks } from '@/config';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/redux/hooks';
import { profileSelectors } from '@/redux/selectors';
import { useModal } from '@/hooks';

import styles from './AccessKeyBlock.module.sass';

interface AccessKeyBlockProps {}

const AccessKeyBlock: FC<AccessKeyBlockProps> = () => {
  const { t } = useTranslation();
  const { data: profileData } = useAppSelector(
    profileSelectors.getProfileSlice,
  );
  const {
    isOpen: isOpenSocialsContactModal,
    onOpenModal: handleOpenSocialsContactModal,
    onCloseModal: handleCloseSocialsContactModal,
  } = useModal();

  return (
    <>
      <FieldInfoGroup
        title={t('translation.user_acess_key_title')}
        description={
          (profileData?.accessKey ? '' : t('translation.access_key_not_set')) ||
          ''
        }
        actions={
          <Button
            type="secondary"
            corner="rect"
            className={styles.actionButton}
            onClick={handleOpenSocialsContactModal}
          >
            {profileData?.accessKey
              ? t('translation.get_new_access_key_link')
              : t('translation.get_access_key_link')}
          </Button>
        }
      >
        {profileData?.accessKey && (
          <div className={styles.code_block}>
            <div className={styles.row}>
              <span className={styles.label}>
                {t('translation.user_access_id_label')}:
              </span>
              <CopyText
                className={styles.strong}
                text={profileData.accessId}
                copyText={profileData.accessId}
              />
            </div>
            <div className={styles.row}>
              <span className={styles.label}>
                {t('translation.user_access_key_label')}:
              </span>
              <CopyText
                className={styles.strong}
                text={profileData.accessKey}
                copyText={profileData.accessKey}
              />
            </div>
            <div className={styles.row}>
              <a
                href={externalLinks.API_DOC_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                {t(
                  'translation.api_documentation_link',
                  'AMLBot Documentation',
                )}
              </a>
            </div>
          </div>
        )}
      </FieldInfoGroup>

      {isOpenSocialsContactModal && (
        <SocialsContactModal
          title={t('translation.support_lnk')}
          onClose={handleCloseSocialsContactModal}
          isOpen
        />
      )}
    </>
  );
};

export default AccessKeyBlock;
